import Joi from 'joi';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
import linkSchema from '@utils/validate/blocksSchemes/linkSchema';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
const DescriptionWidthImageSchema = Joi.object({
  type: Joi.string().valid('descriptionWidthImage').required(),
  code: Joi.string().allow('', null).required(),
  button: linkSchema.allow('', null),
  description: Joi.string().allow('', null),
  image: mediaUrlSchema.allow('', null),
  textColor: Joi.string().allow('', null),
  title: Joi.string().allow('', null),
  ...blockAppearanceSchema
}).unknown(true);
export default DescriptionWidthImageSchema;